import React from 'react';

import t from '@zimpel/common/helpers/i18n';
import { H1 } from '@zimpel/common/components/Headlines';
import { ContentBody, ContentHeader, ContentNarrow } from '@zimpel/common/components/ContentLayout';

const Imprint: React.FC = () => (
  <>
    <ContentHeader>
      <ContentNarrow>
        <H1>{t('view.static_pages.imprint.header')}</H1>
      </ContentNarrow>
    </ContentHeader>

    <ContentBody>
      <ContentNarrow
        // eslint-disable-next-line @typescript-eslint/naming-convention
        dangerouslySetInnerHTML={{ __html: t('view.static_pages.imprint.text') }}
      />
    </ContentBody>
  </>
);

export default Imprint;
